var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nps-bar"},[_c('div',{staticClass:"nb-bar nb-background"}),_c('div',{staticClass:"nb-bar nb-nps",style:({
            left: _vm.deltaPositionRelative + '%',
            width: _vm.deltaWidthPercent + '%',
            background: _vm.npsColor
        })}),_c('div',{staticClass:"nb-average",style:({ left: _vm.middlePercent + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }